import { useState, useEffect, Fragment } from "react";
import {
  CardNumberElement,
  CardExpiryElement,
  CardCvcElement,
  useStripe,
  useElements,
  PaymentRequestButtonElement,
} from "@stripe/react-stripe-js";
import { useNavigate, useLocation } from "react-router-dom";
import toast, { Toaster } from "react-hot-toast";
// import PhoneInput from "react-phone-input-2";
// import "react-phone-input-2/lib/style.css";
import SDK from "../../config";
import Loader from "../Loader/loader";
import handlePaymentSuccess from "./handlePaymentSuccess";
import TrackingScripts from "./trackingComponent";
import { handleSubmit } from "./eventHandler";
import { images } from "../../Constants/imageslinks";

const CheckoutForm = () => {
  const stripe = useStripe();
  const elements = useElements();
  const [email, setEmail] = useState(localStorage.getItem("email") || "");
  // const [phone, setPhone] = useState(localStorage.getItem("phone") || "");
  // const [zipcode, setZipcode] = useState(localStorage.getItem("zipcode") || "");
  const [cardName, setCardName] = useState("");
  const [showCardDetails, setShowCardDetails] = useState(false);
  const [pageLoader, setPageLoader] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const [paymentRequest, setPaymentRequest] = useState(null);
  const [canMakePayment, setCanMakePayment] = useState(false);
  const [regionText, setRegionText] = useState(SDK.REGION_CONFIG.us);
  const DiscountedPrice = SDK.FB_PRICE - SDK.FB_DISOUNT_PRICE;
  const finalDiscountedPrice = Number(DiscountedPrice.toFixed(2));

  const getCurrencySymbol = () => {
    const saveRegion = (localStorage.getItem("region") || "us").toLowerCase();
    switch (saveRegion) {
      case "us":
        return "$"; // USD
      case "uk":
        return "£"; // GBP
      case "eu":
        return "€"; // EUR
      default:
        return "$"; // Default to USD if no region matches
    }
  };

  const handleEmailChange = (e) => {
    const newEmail = e.target.value;
    setEmail(newEmail);
    localStorage.setItem("email", newEmail || email);
  };

  // const handlePhoneChange = (value) => {
  //   setPhone(value);
  //   localStorage.setItem("phone", value);
  // };

  // const handleZipcodeChange = (e) => {
  //   const newZipcode = e.target.value;
  //   setZipcode(newZipcode);
  //   localStorage.setItem("zipcode", newZipcode);
  // };

  useEffect(() => {
    const useremail = params.get("email");
    if (useremail) {
      setEmail(useremail);
      localStorage.setItem("email", useremail);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);

  useEffect(() => {
    if (!stripe) return;

    const paymentOf = "iOS";
    const saveRegion = localStorage.getItem("region") || "us";
    const { currency, price, countryCode } =
      SDK.REGION_CONFIG[saveRegion] || SDK.REGION_CONFIG["us"];
    console.log(
      `code:${countryCode}, region: ${saveRegion},currency: ${currency}, price: ${price}`
    );
    const paymentRequestInstance = stripe.paymentRequest({
      country: countryCode,
      currency: currency,
      total: {
        label: "Total",
        amount: price,
      },
      requestPayerName: true,
      requestPayerEmail: true,
    });

    // Check if the user can make a payment
    paymentRequestInstance
      .canMakePayment()
      .then((result) => {
        setCanMakePayment(result);
        setPaymentRequest(paymentRequestInstance);
      })
      .catch((error) => {
        console.error("Error checking PaymentRequest support:", error);
      });

    // Handle payment method events
    paymentRequestInstance.on("paymentmethod", async (event) => {
      const { paymentMethod, payerEmail } = event;

      try {
        const response = await fetch(
          `${SDK.BASE_URL}/api/create-payment-intent-apple-pay`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              payment_method_id: paymentMethod.id,
              email: payerEmail,
              paymentOf,
              regionCur: currency,
            }),
          }
        );

        const { client_secret: clientSecret } = await response.json();

        if (!clientSecret) {
          throw new Error("Client secret not returned from backend");
        }

        const { error, paymentIntent } = await stripe.confirmCardPayment(
          clientSecret,
          {
            payment_method: paymentMethod.id,
          }
        );

        if (error) {
          console.error("Payment confirmation error:", error);
          event.complete("fail");
          return;
        }

        event.complete("success");

        // Retrieve user details from local storage
        const storeEmail = payerEmail;
        // const storePhone = localStorage.getItem("phone");
        // const storeZipcode = localStorage.getItem("zipcode");
        const methodType = "Apple Pay";
        const paymentWay = "iOS";
        const res = await handlePaymentSuccess(
          paymentIntent,
          methodType,
          storeEmail,
          storeEmail,
          // storePhone,
          // storeZipcode,
          paymentWay
        );
        if (res) {
          if (window.mootrack) {
            window.mootrack("purchesed", email);
          }
          navigate(`/confirmation?email=${encodeURIComponent(storeEmail)}`);
          toast.success("Payment Successful");

          // Clear local storage
          localStorage.removeItem("email");
          localStorage.removeItem("phone");
          localStorage.removeItem("zipcode");
        } else {
          toast.error("Payment Failed");
          event.complete("fail");
        }
      } catch (error) {
        event.complete("fail");
        console.error("Unexpected error during payment processing:", error);
      }
    });
  }, [stripe, navigate]);

  useEffect(() => {
    const saveRegion = (localStorage.getItem("region") || "us").toLowerCase();
    const region = SDK.REGION_CONFIG[saveRegion];
    setRegionText(region);
  }, []);

  return (
    <Fragment>
      <TrackingScripts />
      <Loader pageLoader={pageLoader} style={{ width: "100vw" }} />
      <Toaster />

      <div>
        <div>
          <form
            onSubmit={(event) =>
              handleSubmit(
                event,
                stripe,
                elements,
                email,
                // phone,
                // zipcode,
                CardNumberElement,
                cardName,
                setPageLoader,
                navigate
              )
            }
          >
            <div className="bg-primary200 rounded-sm p-6 md:mt-8 mt-4">
              <div className="bg-primary600 py-4 px-3 rounded-sm">
                <p className="font-inter font-medium text-sm leading-6">
                  1. Friend's details
                </p>

                <div className="flex sm:flex-row flex-col gap-3 mt-5">
                  <div className="flex gap-3 md:flex-row flex-col !md:w-5/7 w-full ">
                    <div className="w-full">
                      <p className="font-inter font-light text-[10px] text-dark-500">
                        Email address
                      </p>
                      <input
                        type="email"
                        placeholder="Email"
                        value={email}
                        onChange={handleEmailChange}
                        required
                        className="rounded-sm h-[34px] border-[0.78px] border-dark-500/20 outline-none px-[10.9px] mt-1 bg-primary-950 font-inter font-normal text-[12.45px] leading-[18.68px] w-full"
                      />
                    </div>
                    {/*<div className="flex flex-col w-full">
                <p className="font-inter font-light text-[10px] text-dark-500 mb-1">
                  Phone number
                </p>
                <div className="w-full">
                  <PhoneInput
                    country={"us"}
                    containerStyle={{ width: "100%" }}
                    inputStyle={{ width: "100%" }}
                    containerClass="w-full h-[34px]"
                    buttonClass="border-none"
                    type="tel"
                    placeholder="Phone"
                    value={phone}
                    onChange={setPhone}
                    required
                  />
                </div>
              </div> */}
                  </div>
                  {/* <div>
                    <p className="font-inter font-light text-[10px] text-dark-500">
                      ZIP code
                    </p>
                    <input
                      type="text"
                      value={zipcode}
                      onChange={handleZipcodeChange}
                      required
                      className="rounded-sm border-[0.78px] border-dark-500/20 outline-none  h-[34px] px-[10.9px]  mt-1 bg-primary-950 font-inter font-normal text-[12.45px] leading-[18.68px] w-full "
                    />
                  </div> */}
                </div>
              </div>

              <div className="bg-primary600 py-4 px-3 mt-6 rounded-sm">
                <div className="flex sm:flex-row flex-col justify-between">
                  <p className="font-inter font-medium text-sm leading-6">
                    2. Payment details
                  </p>
                  <div className="flex gap-2 items-center">
                    <img src={images.visa_card} alt="visa card icon" />
                    <img src={images.master_card} alt="master card icon" />
                    <img src={images.amex_card} alt="amex card icon" />
                    <img src={images.discover_card} alt="discover card icon" />
                    <p className="font-inter font-light text-[10px]">
                      and more
                    </p>
                  </div>
                </div>
                <div className="flex items-start mt-2 gap-2">
                  <img
                    src={images.lock_icon}
                    alt="lock icon"
                    className="-ml-1"
                  />
                  <p className="font-inter font-light text-[10px] leading-[18px] text-dark-100">
                    We protect your payment information using encryption to
                    provide bank-level security.
                  </p>
                </div>

                <div>
                    {canMakePayment && paymentRequest ? (
                      <>
                        <div className="rounded-xs border-[0.78px] p-2 border-dark-500/20 mt-5">
                          <PaymentRequestButtonElement
                            options={{
                              paymentRequest: paymentRequest,
                              style: {
                                paymentRequestButton: {
                                  type: "default",
                                  theme: "dark",
                                  height: "48px",
                                },
                              },
                            }}
                          />
                        </div>
                      </>
                    ) : (
                      ""
                    )}
                  <p className="font-inter font-light text-base leading-[18px] text-center mt-4 text-dark-100">
                    OR
                  </p>
                  {!showCardDetails && (
                    <div>
                      <button
                        onClick={() => {
                          setShowCardDetails(true);
                        }}
                        className="rounded-sm sm:text-[19px] text-sm p-3 bg-secondary100 text-primary100 text-center mt-4 cursor-pointer w-full"
                        type="button"
                      >
                        Pay with credit card
                      </button>
                    </div>
                  )}
                  {showCardDetails && (
                    <div>
                      <div className="flex flex-col md:flex-row gap-2 mt-4">
                        <div className="w-full md:w-5/7 flex gap-3 md:flex-row flex-col">
                          <div className="flex-1">
                            <label className="font-inter font-light text-[10px] text-dark-500 mb-1 block">
                              Name on Card
                            </label>
                            <input
                              type="text"
                              placeholder="Name on Card"
                              value={cardName}
                              onChange={(e) => setCardName(e.target.value)}
                              required
                              className="rounded-sm border-[0.78px] border-dark-500/20 outline-none  h-[34px] px-[10.9px] bg-primary-950 font-inter font-normal text-[12.45px] leading-[18.68px] w-full"
                            />
                          </div>
                          <div className="flex-1">
                            <label className="font-inter font-light text-[10px] text-dark-500 mb-1 block">
                              Card Number
                            </label>
                            <div className="rounded-sm border-[0.78px] border-dark-500/20 bg-primary-950 px-[10.9px]  h-[34px] ">
                              <CardNumberElement
                                options={{
                                  style: {
                                    base: {
                                      lineHeight: "34px",
                                      fontSize: "12.45px",
                                      background: "transparent",
                                      fontWeight: "400",
                                    },
                                  },
                                }}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="flex-1">
                          <label className="font-inter font-light text-[10px] text-dark-500 mb-1 block">
                            Expiry
                          </label>
                          <div className="rounded-sm border-[0.78px] border-dark-500/20 bg-primary-950 px-[10.9px]  h-[34px] min-w-[100px]">
                            <CardExpiryElement
                              options={{
                                style: {
                                  base: {
                                    lineHeight: "34px",
                                    fontSize: "12.45px",
                                    background: "transparent",
                                    fontWeight: "400",
                                    minWidth: "100px",
                                  },
                                },
                              }}
                            />
                          </div>
                        </div>
                        <div className="flex-1">
                          <label className="font-inter font-light text-[10px] text-dark-500 mb-1 block">
                            CVC
                          </label>
                          <div className="rounded-sm border-[0.78px] border-dark-500/20 bg-primary-950 px-[10.9px]  h-[34px] min-w-[100px]">
                            <CardCvcElement
                              options={{
                                style: {
                                  base: {
                                    lineHeight: "34px",
                                    fontSize: "12.45px",
                                    background: "transparent",
                                    fontWeight: "400",
                                  },
                                },
                              }}
                            />
                          </div>
                        </div>
                      </div>
                      <button
                        type="submit"
                        disabled={!stripe}
                        className="rounded-sm sm:text-[19px] text-sm p-3 text-primary100 bg-secondary100 text-center mt-4 cursor-pointer w-full"
                      >
                        {`Gift lifetime access for ${getCurrencySymbol()}${finalDiscountedPrice.toFixed(
                          0
                        )}`}
                      </button>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </form>
        </div>
        <div className="flex flex-col gap-2 mt-5">
          <p className="text-secondary100/50 font-light text-base leading-6">
            Disclaimer
          </p>
          <p className="text-secondary100 font-light text-base leading-6">
            Offer for iOS users only. {regionText.text ?? "USD"} Offer refundable within 7 days of purchase.
          </p>
          {/* <p>
              Due to iOS limitations, we cannot fully replace the iOS home screen,
              but have created widgets to make your home screen as minimal as
              possible. Unfortunately, it can be quite easy to bypass our app, so
              it'll require a little bit more discipline from you!
            </p>  */}
        </div>
      </div>
    </Fragment>
  );
};

export default CheckoutForm;
